/*
  Barklie cart drawer (C1-C3), bovenop Dawn cart-drawer.js / cart.js.
  - ?cart=open opent de drawer (de /cart-pagina stuurt hierheen door)
  - focus naar het kruisje na openen (referentie), zonder Dawn's focus-trap te breken
  - voortgangsbalk animeert van de vorige naar de nieuwe stand (.2s)
  - upsell "+ Add to cart" voegt toe via /cart/add.js en ververst de drawer
  - gratis cadeau (alleen als de instelling aan staat): toevoegen boven de drempel, weghalen eronder;
    kost het cadeau toch geld (geen automatische korting in Shopify), dan weghalen en stoppen
*/
(function () {
  if (window.bkCartInit) return;
  window.bkCartInit = true;

  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  var lastPct = null;
  var giftBusy = false;
  var GIFT_STOP_KEY = 'bk-cart-gift-stop';

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function parse(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(selector);
  }

  // Ververs de drawer zonder hem te openen (Dawn's renderContents opent hem altijd)
  function render(state, opts) {
    var d = drawer();
    if (!d || !state || !state.sections) return;
    var src = state.sections['cart-drawer'] && parse(state.sections['cart-drawer'], '.drawer__inner');
    var dst = d.querySelector('.drawer__inner');
    if (src && dst) dst.innerHTML = src.innerHTML;
    var bubble = document.getElementById('cart-icon-bubble');
    var bubbleSrc = state.sections['cart-icon-bubble'] && parse(state.sections['cart-icon-bubble'], '.shopify-section');
    if (bubble && bubbleSrc) bubble.innerHTML = bubbleSrc.innerHTML;
    var empty = !d.querySelector('.cart-item');
    d.classList.toggle('is-empty', empty);
    if (opts && opts.focus && d.classList.contains('active')) {
      var panel = d.querySelector('.drawer__inner');
      if (panel) panel.focus();
    }
  }

  function post(url, body) {
    var config = typeof fetchConfig === 'function' ? fetchConfig('json') : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    config.body = JSON.stringify(Object.assign({ sections: SECTIONS, sections_url: window.location.pathname }, body));
    return fetch(url, config).then(function (r) {
      return r.json();
    });
  }

  function addUrl() {
    return (window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js';
  }

  function changeUrl() {
    return (window.routes && routes.cart_change_url ? routes.cart_change_url : '/cart/change') + '.js';
  }

  function publishUpdate(state) {
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
      // source 'cart-items': Dawn's drawer-regels halen dan niet nog een keer op
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state });
    }
  }

  /* One complimentary digital guide per cart containing a paid physical product. */
  var ebookVariant = 64151827185994;
  var ebookPending = null;
  var ebookAgain = false;
  function syncEbook() {
    if (ebookPending) { ebookAgain = true; return ebookPending; }
    var cartUrl = (window.routes && routes.cart_url) || '/cart';
    ebookPending = fetch(cartUrl + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('Cart unavailable'); return r.json(); })
      .then(function (cart) {
        var eligible = cart.items.some(function (i) { return i.requires_shipping && i.final_line_price > 0; });
        var gifts = cart.items.filter(function (i) { return i.variant_id === ebookVariant; });
        if (eligible && !gifts.length) return post(addUrl(), { items: [{ id: ebookVariant, quantity: 1, properties: { _bk_ebook: '1' } }] });
        var updates = {};
        if (eligible) cart.items.forEach(function (i) { if (i.variant_id === 64151827153226) updates[i.key] = 0; });
        gifts.forEach(function (i, n) {
          var qty = eligible && n === 0 ? 1 : 0;
          if (i.quantity !== qty) updates[i.key] = qty;
        });
        if (Object.keys(updates).length) return post(cartUrl + '/update.js', { updates: updates });
      })
      .then(function (state) {
        if (!state) return;
        if (state.status) throw new Error(state.description || state.message);
        render(state);
        publishUpdate(state);
      })
      .finally(function () {
        ebookPending = null;
        if (ebookAgain) { ebookAgain = false; scheduleEbook(); }
      });
    return ebookPending;
  }
  var ebookTimer;
  function scheduleEbook() {
    clearTimeout(ebookTimer);
    ebookTimer = setTimeout(function () { syncEbook().catch(console.error); }, 80);
  }
  // Complete the gift update before leaving for checkout, including a rapid click after ATC.
  var ebookCheckoutReady = false;
  document.addEventListener('submit', function (event) {
    if (event.target.id !== 'CartDrawer-Form' || ebookCheckoutReady) return;
    event.preventDefault();
    syncEbook().then(function () {
      // Re-read after any request that was already running.
      return syncEbook();
    }).then(function () {
      ebookCheckoutReady = true;
      var form = document.getElementById('CartDrawer-Form');
      var checkout = document.getElementById('CartDrawer-Checkout');
      if (form && checkout) form.requestSubmit(checkout);
    }).catch(function (error) {
      console.error(error);
      var errors = document.getElementById('CartDrawer-CartErrors');
      if (errors) errors.textContent = 'Please try checkout again.';
    });
  }, true);

  /* ---------- upsell ---------- */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-bk-upsell-add]');
    if (!btn || btn.disabled) return;
    event.preventDefault();
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    post(addUrl(), {
      items: [{ id: Number(btn.getAttribute('data-bk-upsell-add')), quantity: 1 }],
    })
      .then(function (state) {
        if (state.status) throw new Error(state.description || state.message);
        render(state, { focus: true });
        publishUpdate(state);
      })
      .catch(function (e) {
        console.error(e);
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        var errors = document.getElementById('CartDrawer-CartErrors');
        if (errors) errors.textContent = (window.cartStrings && cartStrings.error) || 'Something went wrong. Please try again.';
      });
  });

  /* ---------- slider "Customers also bought": pijltjes ---------- */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-bk-also-nav]');
    if (!btn) return;
    var wrap = btn.closest('.bk-cd__also');
    var track = wrap && wrap.querySelector('.bk-cd__also-track');
    if (!track) return;
    var card = track.querySelector('.bk-cd__also-card');
    var step = card ? card.getBoundingClientRect().width + 12 : track.clientWidth;
    track.scrollBy({ left: Number(btn.getAttribute('data-bk-also-nav')) * step, behavior: 'smooth' });
  });

  /* ---------- voortgangsbalk + cadeau ---------- */
  function syncProgress() {
    var d = drawer();
    if (!d) return;
    var box = d.querySelector('[data-bk-progress]');
    if (!box) {
      lastPct = null;
      return;
    }
    var pct = Number(box.getAttribute('data-bk-progress')) || 0;
    var fill = box.querySelector('.bk-cd__bar-fill');
    if (fill && lastPct !== null && lastPct !== pct && !fill.dataset.bkAnimated) {
      fill.dataset.bkAnimated = '1';
      fill.style.transition = 'none';
      fill.style.width = lastPct + '%';
      void fill.offsetWidth;
      fill.style.transition = '';
      fill.style.width = pct + '%';
    }
    lastPct = pct;
    syncGift(box);
  }

  function giftStopped() {
    try {
      return sessionStorage.getItem(GIFT_STOP_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function syncGift(box) {
    var state = box.getAttribute('data-bk-gift-state');
    // cadeau eerder niet gratis gebleken (geen korting): balk verbergen, niets beloven
    if (state && box.hasAttribute('data-bk-gift-variant') && giftStopped()) box.hidden = true;
    if (!state || state === 'ok' || giftBusy) return;
    var line = Number(box.getAttribute('data-bk-gift-line')) || 0;
    var variant = Number(box.getAttribute('data-bk-gift-variant')) || 0;
    var request = null;

    if (state === 'add' && variant && !giftStopped()) {
      request = post(addUrl(), { items: [{ id: variant, quantity: 1, properties: { _bk_gift: '1' } }] });
    } else if ((state === 'remove' || state === 'paid') && line) {
      if (state === 'paid') {
        console.warn('Barklie cart: het cadeau wordt niet gratis gemaakt (geen automatische korting in Shopify). Cadeau weggehaald; maak eerst de korting aan.');
        try {
          sessionStorage.setItem(GIFT_STOP_KEY, '1');
        } catch (e) {}
      }
      request = post(changeUrl(), { line: line, quantity: 0 });
    }
    if (!request) return;

    giftBusy = true;
    request
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message);
        render(res);
        publishUpdate(res);
      })
      .catch(function (e) {
        console.error(e);
      })
      .finally(function () {
        giftBusy = false;
      });
  }

  /* ---------- openen via ?cart=open, focus op het kruisje ---------- */
  customElements.whenDefined('cart-drawer').then(function () {
    var Ctor = customElements.get('cart-drawer');
    if (Ctor && !Ctor.prototype.bkPatched) {
      var open = Ctor.prototype.open;
      Ctor.prototype.open = function (triggeredBy) {
        var wasOpen = this.classList.contains('active');
        open.call(this, triggeredBy);
        if (wasOpen) return;
        var self = this;
        this.addEventListener(
          'transitionend',
          function () {
            var close = self.querySelector('.bk-cd__close');
            if (close) close.focus();
          },
          { once: true }
        );
      };
      Ctor.prototype.bkPatched = true;
    }

    var d = drawer();
    if (!d) return;

    var cartBox = document.getElementById('CartDrawer');
    if (cartBox && 'MutationObserver' in window) {
      var timer = null;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(syncProgress, 30);
        scheduleEbook();
      }).observe(cartBox, { childList: true, subtree: true });
    }
    syncProgress();
    scheduleEbook();
    window.addEventListener('pageshow', function () { ebookCheckoutReady = false; scheduleEbook(); });

    var params = new URLSearchParams(window.location.search);
    if (params.get('cart') === 'open') {
      params.delete('cart');
      var qs = params.toString();
      history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
      setTimeout(function () {
        d.open();
      }, 50);
    }
  });
})();
